import { CellTable } from "@/atoms"
import { getDefaultColumnParams } from "@/helpers/table.helpers"
import { TFunction } from "@/hooks/useTranslation"
import { UserCell } from "@/pages/SettingsPage/components/molecules/UserCell"
import { StatusTag } from "../../molecules/StatusTag"
import { UserActionsCell } from "../../molecules/UserActionsCell"

import { UserEntity } from "@/domain/user"
import type { ORDER_BY_PROPS } from "@/hooks/useOrderBy"
import type { ColumnType } from "antd/es/table"
import { UserScopesCell } from "../../molecules/UserScopesCell"

export const getColumnsTable = (
  sorter: Omit<ORDER_BY_PROPS, "onSorterChange">,
  {
    t,
    hasUsersWritePermissions,
    resetOrResendPassword,
    deleteUser,
    editUser
  }: {
    t: TFunction
    hasUsersWritePermissions: boolean | undefined
    resetOrResendPassword: any
    deleteUser: any
    editUser: any
  }
): ColumnType<Required<UserEntity>>[] => {
  const columns = [
    {
      title: t("settings.users.columns.user"),
      width: "29%",
      render: UserCell,
      ...getDefaultColumnParams("email", sorter)
    },
    {
      title: t("settings.users.columns.role"),
      width: 95,
      render: (value: string) => {
        return t(`settings.users.roles.${value}`)
      },
      ...getDefaultColumnParams("role", sorter)
    },
    {
      title: t("settings.users.columns.jobDescription"),
      width: "13%",
      render: CellTable,
      ...getDefaultColumnParams("jobDescription", sorter)
    },
    {
      title: t("settings.users.columns.scopes"),
      width: "24%",
      sorter: false,
      render: UserScopesCell(t)
    },
    {
      title: t("settings.users.columns.status"),
      width: "10%",
      render: StatusTag(t),
      ...getDefaultColumnParams("status", sorter)
    },
    {
      title: t("settings.users.columns.lastSeen"),
      width: "10%",
      sorter: true,
      showSorterTooltip: false,
      ...getDefaultColumnParams("lastLogin", sorter)
    },
    {
      width: 35,
      render: UserActionsCell({
        t,
        resetOrResendPassword,
        deleteUser,
        editUser
      })
    }
  ]

  if (!hasUsersWritePermissions) {
    return columns.slice(0, 3).concat(columns.slice(4, -1))
  }
  return columns
}
